import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { SlidingPanelsContext } from './SlidingPanel.context';

/**
 * PanelLink is used within a SlidingPanel to provide the onClick functionality
 * to slide the associated panel
 */
const PanelLink = ({ children, forPanelId, onClick, ...props }) => {
  const context = useContext(SlidingPanelsContext);
  /**
   * Handles showing a sliding panel onclick by forPanelId
   *
   * @param {SyntheticBaseEvent} e React synthetic event
   */
  const handleClick = (e) => {
    if (context && forPanelId) {
      const { addPanel } = context;

      addPanel(forPanelId);
    }

    if (onClick) {
      onClick(e);
    }
  };

  return React.Children.only(
    React.cloneElement(children, {
      onClick: handleClick,
      ...props
    })
  );
};

PanelLink.propTypes = {
  /**
   * Children component that opens a Sliding Panel
   */
  children: PropTypes.node.isRequired,
  /**
   * Panel ID the children component is related to.
   * If specified, will be used for updating SlidingPanelsContext.
   */
  forPanelId: PropTypes.string,
  /**
   * Handler for optional click event
   */
  onClick: PropTypes.func
};

PanelLink.defaultProps = {
  forPanelId: null,
  onClick: null
};

export default PanelLink;
